module.exports = __webpack_public_path__ + "img/lotto-5-45-mobile.430e7a23.png";